import React, { Component } from 'react';
import jquery from 'jquery';
import { Table, Input, Select, Popconfirm, Button, message } from 'antd';
import HighSearchInput from '../../common/HighSearchInput';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const { Option } = Select;
const { TextArea } = Input;
const roleList = [{
    name: 'PI',
    value: 'PI',
}, {
    name: 'Sub-I',
    value: 'SUB_1',
}, {
    name: '研究护士',
    value: 'Research_nurse',
}, {
    name: '其他(药师、技师等)',
    value: 'Others',
}];
const typeList = [{
    name: '优选名单',
    value: 'Preferred_List',
}, {
    name: '固定site',
    value: 'Fixed_Site',
}, {
    name: '经验要求',
    value: 'Experience_Requirement',
}, {
    name: '需要面试',
    value: 'Interview_Required',
}, {
    name: '需要备案',
    value: 'Need_To_File',
}, {
    name: '项目数量限制',
    value: 'Project_Quantity_Limit',
}, {
    name: '人数限制',
    value: 'People_Of_Number',
}, {
    name: '指定其他SMO',
    value: 'Specify_Other_SMO',
}, {
    name: '其他',
    value: 'Other',
}];
                    
class EditableCell extends Component {
    handleInputChange = (e) => {
        const { type } = this.props;
        this.props.onChange({ [type]: e.target.value });
    }

    handleSelectChange = (value) => {
        const { type } = this.props;
        const params = {};
        if (type === 'requirementType') {
            params[type] = value ? value.join(',') : '';
        } else {
            params[type] = value;
        }
        this.props.onChange(params);
    }

    handleHighSearchInputChange = (id, options) => {
        const option = options.find(i => i.value == id);
        const { value, userCompellation } = option || {};
        this.props.onChange({
            userId: value,
            userCompellation,
            isSelectFalse: id ? value ? false : true : false,
        });
    }
 
    getContent = () => {
        const { type, params } = this.props;
        const { requirementRole, userId, employeeCode, userCompellation, requirementType, requirementComments, hospitalDepartmentId } = params;
        if (type === 'requirementRole') {
            const options = roleList.map(i => <Option key={i.value}>{i.name}</Option>)
            return (
                <Select
                    style={{ width: '100%' }}
                    onChange={(value) => this.handleSelectChange(value)}
                    value={requirementRole}
                    placeholder="请选择"
                >
                    {options}
                </Select>
            )
        } else if (type === 'userCompellation') {
            return (
                <HighSearchInput
                    isEdit={true}
                    keyword='keyword'
                    style={{ width: '100%' }}
                    params={{ limit: 20, hospitalDepartmentId }}
                    placeholder="输入姓名/手机号检索"
                    url={API_URL.hospital.queryDoctorListByHospitalDepartment}
                    initValue={{ key: userId, label: userCompellation }}
                    config={{ id: 'userId', name: 'userCompellation', type: 'researcher' }}
                    onChange={(id, options) => this.handleHighSearchInputChange(id, options)}
                />
            )
        } else if (type === 'requirementType') {
            const options = typeList.map(i => <Option key={i.value}>{i.name}</Option>);
            return (
                <Select
                    mode="multiple"
                    filterOption={false}
                    style={{ width: '100%' }}
                    placeholder="请选择"
                    onChange={(value) => this.handleSelectChange(value)}
                    value={requirementType ? requirementType.split(',') : []}
                >
                    {options}
                </Select>
            )
        } else if (type === 'requirementComments') {
            return (
                <TextArea
                    rows={3}
                    maxLength="200"
                    placeholder="请输入"
                    value={requirementComments}
                    onChange={this.handleInputChange}
                    style={{ width: '100%' }}
                />
            )
        }
    }

    render () {
        const { editable, value, type, params: { requirementRole, requirementType } } = this.props;
        let result = value;
        if (type === 'requirementRole') {
            const role = roleList.find(r => r.value === requirementRole);
            const { name } = role || {};
            result = name;
        } else if (type === 'requirementType') {
            let str = '';
            const array = requirementType ? requirementType.split(',') : [];
            array.forEach(i => {
                const type = typeList.find(t => t.value === i);
                const { name } = type || {};
                str += `${name},`;
            });
            result = str ? str.slice(0, str.length - 1) : '';
        }
        return (
            <div>
                {
                    editable ?
                        this.getContent()
                    :
                        result
                }
            </div>
        )
    }
}

class RequirementTable extends Component {
    state = {
        count: 0,
        loading: false,
        dataSource: [],
    }

    componentDidMount() {
        const { dataSource } = this.props;
        const newDataSource = dataSource.map((item, index) => {
            item.key = index;
            return item;
        });
        this.setState({
            count: dataSource.length,
            dataSource: newDataSource,
        });
    }

    componentWillReceiveProps(nextProps) {
        const { isEdit, loading, dataSource = [] } = nextProps;
        if ((!this.props.isEdit && isEdit) || (this.props.loading && !loading)) {
            const newDataSource = dataSource.map((item, index) => {
                item.key = index;
                return item;
            });
            this.setState({
                count: dataSource.length,
                dataSource: newDataSource,
            });
        }
    }

    handleChange = (value, key) => {
        const newData = [...this.state.dataSource];
        const target = newData.find(item => key === item.key);
        if (target) {
            const entries = Object.entries(value || {});
            entries.forEach(entry => {
                target[entry[0]] = entry[1];
            });
            this.setState({ dataSource: newData });
        }
    }

    edit = (key) => {
        const newData = [...this.state.dataSource];
        const target = newData.find(item => key === item.key);
        newData.forEach(i => i.editable = false);
        if (target) {
            target.editable = true;
            this.setState({ dataSource: newData });
        }
    }

    save = (key) => {
        const { reviewDepartmentId, hospitalDepartmentId } = this.props;
        const newData = [...this.state.dataSource];
        const target = newData.find(item => key === item.key);
        if (target) {
            const { requirementRole, userId, requirementType, requirementComments, isSelectFalse, reviewDepartmentRequirementId } = target;
            if (!requirementRole && !userId && !requirementType && !requirementComments) {
                message.warning('尚未填写，不予保存');
                return;
            }
            if (userId && isSelectFalse) {
                message.warning('请选择正确的要求人');
                return;
            }
            const url = reviewDepartmentRequirementId ? API_URL.hospital.modifyReviewDepartmentRequirement : API_URL.hospital.addReviewDepartmentRequirement;
            this.setState({ loading: true });
            const options = {
                method: 'POST',
                url,
                data: {
                    reviewDepartmentId,
                    hospitalDepartmentId,
                    ...target,
                },
                dataType: 'json',
                doneResult: res => {
                    const { success, reviewDepartmentId, reviewDepartmentRequirementId } = res;
                    message.success(success);
                    if (reviewDepartmentRequirementId) {
                        target.reviewDepartmentRequirementId = reviewDepartmentRequirementId;
                    }
                    target.editable = false;
                    this.setState({
                        loading: false,
                        dataSource: newData,
                    }, () => {
                        this.props.onChange(reviewDepartmentId);
                    });
                },
                errorResult: () => {
                    this.setState({ loading: false });
                }
            };
            $.sendRequest(options);
        }
    }

    cancel = (key) => {
        const newData = [...this.state.dataSource];
        let idx;
        newData.forEach((item, index) => {
            if (item.key == key) {
                if (item.reviewDepartmentRequirementId) {
                    idx = index
                    this.setState({ loading: true });
                    const options = {
                        method: 'POST',
                        url: API_URL.hospital.deleteReviewDepartmentRequirement,
                        data: {
                            reviewDepartmentRequirementId: item.reviewDepartmentRequirementId,
                        },
                        dataType: 'json',
                        doneResult: res => {
                            message.success(res.success);
                            newData.splice(idx, 1);
                            this.setState({
                                loading: false,
                                dataSource: newData,
                            });
                        },
                        errorResult: () => {
                            this.setState({ loading: false });
                        }
                    };
                    $.sendRequest(options);
                } else {
                    idx = index;
                    if (idx >= 0) {
                        newData.splice(idx, 1);
                        this.setState({ dataSource: newData });
                    }
                }
            }
        });
    }

    getColumns = () => {
        const { isEdit, hospitalDepartmentId } = this.props;
        const columns = [{
            title: '要求人角色',
            dataIndex: 'requirementRole',
            key: 'requirementRole',
            width: 150,
            render: (text, record, index) => {
                const { key, editable } = record;
                return (
                    <EditableCell
                        editable={isEdit && editable}
                        value={text}
                        params={{ ...record, hospitalDepartmentId }}
                        type='requirementRole'
                        onChange={value => this.handleChange(value, key)}
                    />
                )
            }
        }, {
            title: '要求人姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 180,
            render: (text, record, index) => {
                const { key, editable } = record;
                return (
                    <EditableCell
                        editable={isEdit && editable}
                        value={text}
                        params={{ ...record, hospitalDepartmentId }}
                        type='userCompellation'
                        onChange={value => this.handleChange(value, key)}
                    />
                )
            }
        }, {
            title: '要求类型',
            dataIndex: 'requirementTypeShow',
            key: 'requirementTypeShow',
            width: 200,
            render: (text, record, index) => {
                const { key, editable } = record;
                return (
                    <EditableCell
                        editable={isEdit && editable}
                        value={text}
                        params={{ ...record, hospitalDepartmentId }}
                        type='requirementType'
                        onChange={value => this.handleChange(value, key)}
                    />
                )
            }
        }, {
            title: '要求描述',
            dataIndex: 'requirementComments',
            key: 'requirementComments',
            width: 200,
            render: (text, record, index) => {
                const { key, editable } = record;
                return (
                    <EditableCell
                        editable={isEdit && editable}
                        value={text}
                        params={record}
                        type='requirementComments'
                        onChange={value => this.handleChange(value, key)}
                    />
                )
            }
        }];

        if (isEdit) {
            columns.push({
                title: '操作',
                key: 'operation',
                width: 80,
                render: (text, record, index) => {
                    const { key, editable } = record;
                    return (
                        <span>
                            {
                                editable ?
                                    <a onClick={() => this.save(key)}>保存</a>
                                :
                                    <a onClick={() => this.edit(key)}>修改</a>
                            }
                            <span className="ant-divider" />
                            <Popconfirm title="确定要删除该行数据?" onConfirm={() => this.cancel(key)}>
                                <a>删除</a>
                            </Popconfirm>
                        </span>
                    )
                },
            });
        }
        return columns;
    }

    handleAdd = () => {
        const { count, dataSource } = this.state;
        const newData = {
          key: count,
          editable: true,
        };
        dataSource.forEach(i => i.editable = false);
        this.setState({
          dataSource: [...dataSource, newData],
          count: count + 1,
        });
    }

    render() {
        const { loading, dataSource } = this.state;
        const { isEdit } = this.props;
        const scrollX = isEdit ? 810 : 730;
        // 处理表头分组没数据时，不显示滚动条的bug
        setTimeout(() => {
            if (!dataSource.length) {
                jquery('.showScroll .ant-table-scroll .ant-table-header').css('margin-bottom', 0);
            } else {
                jquery('.showScroll .ant-table-scroll .ant-table-header').css('margin-bottom', -16);
            }
        }, 100)
        return (
            <div className='showScroll' style={{ marginBottom: 10 }}>
                { isEdit && <Button onClick={this.handleAdd} style={{ marginBottom: 10 }}>添加行</Button> }
                <Table
                    bordered
                    loading={loading}
                    pagination={false}
                    scroll={{ x: scrollX, y: 280 }}
                    columns={this.getColumns()}
                    dataSource={dataSource}
                    rowKey={record => record.key}
                />
            </div>
        )
    }
}

export default RequirementTable;


// WEBPACK FOOTER //
// ./src/components/hospital/commentInfo/RequirementTable.js